import React, { Component } from "react";
import Card from "../components/Card";
import { db } from "../config";
import loading from "../Ellipsis-1s-200px.svg";
import "isomorphic-unfetch";

export default class ApplicantView extends Component {
  state = {
    applicationId: this.props.match.params.id,
    jobId: this.props.match.params.jobId,
    applicant: null
  };

  componentDidMount() {
    db
      .collection(this.state.jobId)
      .where("id", "==", this.state.applicationId)
      .get()
      .then(docs => {
        let temp;
        docs.forEach(doc => (temp = doc.data()));
        this.setState({ applicant: temp });
      });
  }

  render() {
    const applicant = this.state.applicant;
    return (
      <div className="mt4 pb6" style={{ minHeight: 700 }}>
        {!applicant ? (
          <Loading />
        ) : (
          <Card
            className="bg-white center"
            style={{ height: "fit-content", maxWidth: 750 }}
          >
            <div className="flex">
              <div>
                <img alt="" src={applicant.pic} height="300" width="300" />
              </div>
              <div className="pl4 f4" style={{ lineHeight: 2 }}>
                <h4 className="f3 fw5">
                  <span className="blue">Fullname:</span> {applicant.firstname}{" "}
                  {applicant.middlename || ""} {applicant.lastname}
                </h4>
                <p>
                  <span className="blue">Reference:</span> {applicant.id}
                </p>
                <p>
                  <span className="blue">Age:</span> {applicant.age}
                </p>
                <p>
                  <span className="blue">Highest Qualification:</span>{" "}
                  {applicant.highestQualification || ""}
                </p>
                <p>
                  <span className="blue">Course of study:</span>{" "}
                  {applicant.course || ""}
                </p>
                <p>
                  <span className="blue">Graduation Date:</span>{" "}
                  {applicant.graduationDate || ""}
                </p>
                <p>
                  <span className="blue">Grade:</span> {applicant.grade}
                </p>
                <p>
                  <span className="blue">State of origin:</span>{" "}
                  {applicant.stateOfOrigin}
                </p>
                <p>
                  <span className="blue">Years of experience:</span>{" "}
                  {applicant.yearsOfExperience || ""}
                </p>
                <p>
                  <span className="blue">Email:</span> {applicant.email}
                </p>
                <p>
                  <span className="blue">Phone number:</span>{" "}
                  {applicant.phonenumber || ""}
                </p>
              </div>
            </div>
            <div className="mt2 f4" style={{ lineHeight: 3 }}>
              <p>
                <span className="blue">Other qualifications:</span>{" "}
                {applicant.otherQualifications || ""}
              </p>
              <div>
                <h6 className="blue">Experience (description):</h6>
                <p>{applicant.experienceDescription || ""}</p>
              </div>
            </div>
            <p className="mt2">
              <a className="button is-light" href={applicant.cv} download="">
                get CV
              </a>
            </p>
          </Card>
        )}
      </div>
    );
  }
}

const Loading = () => (
  <div className="tc mt4">
    <img alt="" src={loading} className="h2 w2" />
  </div>
);



// WEBPACK FOOTER //
// ./src/pages/applicantView.js